module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("“You’re looking for Skizz.” Ed’s skin felt tight as he said it. The thought had just popped into his brain, and he wasn’t sure where it had come from. But as soon as it left his lips, he knew it was true. He could tell by the wild, wary look that flashed in Gaia’s eyes, the sudden tightening of the line of her body. The way her hand tensed on the strap of her bag. Her knuckles, he noticed, were grazed and raw.")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Then Gaia relaxed. Her face became a careful mask. “I wanted to ask him some questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not true,” Ed said evenly, looking into Gaia’s eyes. “You’re looking for Skizz, and it isn’t to ask him some questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, don’t worry about it,” Gaia said. She looked around with studied casualness. She shifted her feet. Obviously she wanted him gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed suddenly felt afraid. Afraid for Gaia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afraid "), _c('em', [_vm._v("of")]), _vm._v(" Gaia.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c0e686c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 60
// module chunks = 0